import request from "@/utils/request";

export function saveAssessmentDraft(domain, answers, companyType) {
  return request({ url: `/assessment-drafts/${domain}`, method: 'put', data: { answers, companyType } })
}

export function getAssessmentDraft(domain) {
  return request({ url: `/assessment-drafts/${domain}`, method: 'get' })
}

export function deleteAssessmentDraft(domain) {
  return request({ url: `/assessment-drafts/${domain}`, method: 'delete' })
}

//获取会员展示图片
export function getSelfAssessMent() {
  return request({
    url: "/selfassessment",
    method: "get"
  });
}

export function submitAiAssessment(answers) {
  return request({ url: "/ai-assessments", method: "post", data: { answers } });
}

export function getLatestAiAssessment() {
  return request({ url: "/ai-assessments/latest", method: "get" });
}

export function getAiAssessmentHistory() {
  return request({ url: "/ai-assessments/history", method: "get" });
}

export function getAiAssessmentDetail(assessmentId) {
  return request({ url: `/ai-assessments/${assessmentId}`, method: "get" });
}

export function uploadAiEvidence(assessmentId, indicatorId, files) {
  const data = new FormData();
  files.forEach(file => data.append("files", file.raw || file));
  return request({
    url: `/ai-assessments/${assessmentId}/indicators/${indicatorId}/evidence`,
    method: "post",
    data
  });
}

export function submitMaterialAssessment(answers) {
  return request({ url: '/material-assessments', method: 'post', data: { answers } })
}

export function getLatestMaterialAssessment() {
  return request({ url: '/material-assessments/latest', method: 'get' })
}

export function uploadMaterialEvidence(assessmentId, indicatorId, files) {
  const data = new FormData()
  files.forEach(file => data.append('files', file.raw || file))
  return request({
    url: `/material-assessments/${assessmentId}/indicators/${indicatorId}/evidence`,
    method: 'post',
    data
  })
}

export function submitEnergyAssessment(answers, companyType) {
  return request({ url: '/energy-assessments', method: 'post', data: { answers, companyType } })
}

export function getLatestEnergyAssessment() {
  return request({ url: '/energy-assessments/latest', method: 'get' })
}

export function uploadEnergyEvidence(assessmentId, indicatorId, files) {
  const data = new FormData()
  files.forEach(file => data.append('files', file.raw || file))
  return request({ url: `/energy-assessments/${assessmentId}/indicators/${indicatorId}/evidence`, method: 'post', data })
}

export function submitSoftwareAssessment(answers) {
  return request({ url: '/software-assessments', method: 'post', data: { answers } })
}

export function getLatestSoftwareAssessment() {
  return request({ url: '/software-assessments/latest', method: 'get' })
}

export function uploadSoftwareEvidence(assessmentId, indicatorId, files) {
  const data = new FormData()
  files.forEach(file => data.append('files', file.raw || file))
  return request({ url: `/software-assessments/${assessmentId}/indicators/${indicatorId}/evidence`, method: 'post', data })
}

export function submitIntegratedCircuitAssessment(answers, companyType) {
  return request({ url: '/integrated-circuit-assessments', method: 'post', data: { answers, companyType } })
}

export function getLatestIntegratedCircuitAssessment() {
  return request({ url: '/integrated-circuit-assessments/latest', method: 'get' })
}

export function uploadIntegratedCircuitEvidence(assessmentId, indicatorId, files) {
  const data = new FormData()
  files.forEach(file => data.append('files', file.raw || file))
  return request({ url: `/integrated-circuit-assessments/${assessmentId}/indicators/${indicatorId}/evidence`, method: 'post', data })
}

export function submitEmergencyAssessment(answers, companyType) {
  return request({ url: '/emergency-assessments', method: 'post', data: { answers, companyType } })
}

export function getLatestEmergencyAssessment() {
  return request({ url: '/emergency-assessments/latest', method: 'get' })
}

export function uploadEmergencyEvidence(assessmentId, indicatorId, files) {
  const data = new FormData()
  files.forEach(file => data.append('files', file.raw || file))
  return request({ url: `/emergency-assessments/${assessmentId}/indicators/${indicatorId}/evidence`, method: 'post', data })
}
